//export const username = state => state.username
export const token = state => state.token
export const stepActiveIndex = state => state.stepActiveIndex
export const showLogin = state => state.showLogin
export const checkedEmail = state => state.checkedEmail
export const isEmailBind = state => state.isEmailBind
export const user = state => state.user
export const uid = state => state.uid
export const redirect = state => state.redirect



// WEBPACK FOOTER //
// ./src/store/getters.js